module.exports = __webpack_public_path__ + "static/JDM-5dfc216b3bdc11b76c808d6856e50f85.png";